import React, { Component } from 'react';
import I18n from 'i18n-js';
import { Spin, Icon } from 'grab-ui';

import css from './gfb-redirect.less';

class GfbRedirect extends Component {
  constructor(props) {
    super(props);
    this.redirectTimeout = null;
  }

  componentDidMount() {
    this.redirectTimeout = setTimeout(() => {
      this.onClickRedirectGfb();
    }, 3000);
  }

  onClickRedirectGfb = () => {
    const { endpoints } = window.Grab.config;
    const currentURL = window.location.href.replace('/redirect-to-gfb', '');
    clearTimeout(this.redirectTimeout);
    window.location.replace(`${endpoints.gfbAdmin}?redirectUrl=${currentURL}`);
  };

  render() {
    return (
      <div className={css.wrapper}>
        <div className={css.contentWrapper}>
          <img src={require('public/images/gfb-redirect.png')} alt="" />
          <div className={css.loadingWrapper}>
            <Spin
              indicator={<Icon type="loading" style={{ fontSize: 24 }} spin />}
            />
            <div className={css.textWrapper}>
              <h4>{I18n.t('v2.redirectGfbPage.message')}</h4>
              <h6>
                {I18n.t('v2.redirectGfbPage.clickPrefix')}{' '}
                <span
                  onClick={this.onClickRedirectGfb}
                  role="button"
                  tabIndex="0"
                  onKeyDown={null}
                >
                  {I18n.t('v2.redirectGfbPage.click')}
                </span>
              </h6>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default GfbRedirect;
